var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3 15.7C0.116667 15.5167 0.0250001 15.2833 0.0250001 15C0.0250001 14.7167 0.116667 14.4833 0.3 14.3L1.675 12.925C1.14167 12.2417 0.729334 11.4833 0.438 10.65C0.146667 9.81667 0.000666667 8.93333 0 8C0 5.76667 0.775 3.875 2.325 2.325C3.875 0.775 5.76667 0 8 0H14C14.55 0 15.021 0.195667 15.413 0.587C15.805 0.978333 16.0007 1.44933 16 2V8C16 10.2333 15.225 12.125 13.675 13.675C12.125 15.225 10.2333 16 8 16C7.06667 16 6.18767 15.8543 5.363 15.563C4.53833 15.2717 3.784 14.859 3.1 14.325L1.7 15.7C1.51667 15.8833 1.28333 15.975 1 15.975C0.716667 15.975 0.483334 15.8833 0.3 15.7ZM4.35 11.65C4.53333 11.8667 4.76667 11.9707 5.05 11.962C5.33333 11.9533 5.575 11.8493 5.775 11.65L9.7 7.725C9.9 7.525 10 7.28733 10 7.012C10 6.73667 9.9 6.49933 9.7 6.3C9.51667 6.11667 9.28333 6.025 9 6.025C8.71667 6.025 8.48333 6.11667 8.3 6.3L4.35 10.25C4.16667 10.4333 4.075 10.6627 4.075 10.938C4.075 11.2133 4.16667 11.4507 4.35 11.65Z",
    fill: "#96B77A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIcon);
export default __webpack_public_path__ + "static/media/leaf-icon.b536b1c00b6a6efa72024d5b9392f752.svg";
export { ForwardRef as ReactComponent };